function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "18",
  viewBox: "0 0 15 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_134_58)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.89 11.191a4.414 4.414 0 01-.27-2.41 3.747 3.747 0 011.457-2.409c.135-.096.275-.182.421-.259-1.001-1.63-2.632-1.88-3.144-1.935-1.116-.12-2.689.774-3.538.788h-.02c-.855-.014-2.427-.908-3.538-.788-.556.06-2.332.44-3.4 2.2a5.907 5.907 0 00-.785 2.408c-.044.39-.064.781-.058 1.173.005.414.036.827.093 1.237.12.827.336 1.635.643 2.409a11.18 11.18 0 001.158 2.189c.952 1.391 2.03 2.196 2.638 2.21 1.25.03 2.335-.844 3.23-.82h.05a.07.07 0 00.028 0c.895-.024 1.982.85 3.231.82.608-.014 1.687-.819 2.64-2.21a11.184 11.184 0 001.295-2.563 3.456 3.456 0 01-1.282-.78 3.594 3.594 0 01-.848-1.26z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.996 2.946c.965-1.173.922-2.86.835-2.936-.087-.076-1.672.226-2.655 1.36-.982 1.133-.923 2.86-.836 2.936.087.076 1.692-.184 2.656-1.36z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_134_58"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v18H0z"
})))));